var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "c") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unroll-Marketing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "App-Password---2",
    transform: "translate(-708.000000, -416.000000)",
    fill: "#00D9B9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Step-1",
    transform: "translate(570.000000, 360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sign-in-AOL",
    transform: "translate(131.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2437969,7.61037661 C20.4512051,7.77889572 20.4857731,8.08568693 20.3577434,8.34638743 L20.3021305,8.44162954 C20.3021305,8.44162954 14.7750277,16.3312406 14.3229428,16.9583262 C13.7104406,17.7895791 12.5437698,17.8333292 11.9021009,16.9583262 L7.84792,11.2562228 L7.84792,11.2562228 C7.658336,10.9791385 7.67291938,10.6145538 7.90625354,10.4103865 C8.416672,9.97288492 8.97084061,9.59371692 9.56875938,9.25829908 C9.83126031,9.12704861 10.1812615,9.22913231 10.3708455,9.50621661 L13.1125218,13.3562302 L17.7937883,6.70620677 C17.9833723,6.42912246 18.3333735,6.32703877 18.5958745,6.47287261 C19.1792098,6.79370707 19.7333785,7.15829169 20.2437969,7.61037661 Z",
    id: "c"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.5c2874a3017fc0cf6bc9056ba940be6d.svg";
export { ForwardRef as ReactComponent };